<template>
  <svg
    id="Investment-Agreement--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <desc>Investment Agreement Streamline Icon: https://streamlinehq.com</desc>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12.6392 3.94283 9.40839 6.78175c-0.70288 0.61762 -0.8127 1.67187 -0.25219 2.42109 0.58599 0.78327 1.6916 0.95236 2.4849 0.37998l3.6855 -2.6591 1.1702 1.62191 -2.2567 1.62817c1.4145 1.1059 2.2596 2.8108 2.2596 4.6357 0 1.07 -0.2914 2.1087 -0.8286 3.0109l0.4861 0.0694c0.6147 0.0878 1.2415 0.0313 1.8306 -0.1651l3.0121 -1.004V17c0 0.5523 0.4477 1 1 1h2V5h-2c-0.5523 0 -1 0.44772 -1 1v0.38208l-4.9968 -2.49839C15.4985 3.63136 14.942 3.5 14.3778 3.5c-0.6102 0 -1.2076 0.15357 -1.7386 0.44283ZM8.08829 5.27936l0.788 -0.69241C8.27989 4.20662 7.58274 4 6.86429 4c-0.76772 0 -1.51687 0.23615 -2.14581 0.67641L2.99334 5.884C2.93586 5.38636 2.51305 5 2 5H0v13h2c0.55228 0 1 -0.4477 1 -1v-0.1633l4.81653 2.8332c1.06434 0.6261 2.40357 0.5361 3.37457 -0.2268l0.9933 -0.7805 1.0869 -1.0185c0.7838 -0.7344 1.2285 -1.7606 1.2285 -2.8346 0 -1.3833 -0.7356 -2.6623 -1.9313 -3.3578l-0.0724 -0.0421c-1.6451 0.9572 -3.77758 0.5468 -4.94128 -1.0087 -1.1857 -1.58486 -0.9534 -3.81503 0.53347 -5.12154Z"
      clip-rule="evenodd"
      stroke-width="1"
    />
  </svg>
</template>
